import { useSelector } from 'react-redux';
import useSelectedCommunity from './useSelectedCommunity';
import { RootState } from '../../redux/reducers';
import { Post } from '../../types/post';

export default function usePosts(): Post[] | null {
  const selectedCommunity = useSelectedCommunity();
  const communityId = selectedCommunity?.id;

  const posts = useSelector((state: RootState) => {
    if (!communityId) return null;
    return state.posts.posts[communityId] ?? null;
  });

  return posts;
}
